import type { FC } from 'react';

import { Modal, Row, Typography } from 'enable-ui';

import { CancelButton } from 'modules/dashboard/styles/dashboard';

import { ModalContainer, SubmitConfirmButton } from 'components/modal/styles/ConfirmModal';

import type { ConfirmModalProps } from './type';

export const ConfirmModal: FC<ConfirmModalProps> = ({
  cancelButton,
  submitButton,
  content,
  header,
  onCancel,
  onSubmit,
  modalKey,
}) => {
  return (
    <ModalContainer>
      <Modal
        header={header}
        modalKey={modalKey}
        size="md"
        footer={
          <Row align="center" justify="end" style={{ padding: '21px 24px 24px', gap: 10 }}>
            {!cancelButton?.hide && (
              <CancelButton size="large" onClick={onCancel} {...cancelButton?.buttonProps}>
                {cancelButton?.label ?? 'Cancel'}
              </CancelButton>
            )}

            {!submitButton?.hide && (
              <SubmitConfirmButton
                color="danger"
                size="large"
                {...submitButton?.buttonProps}
                onClick={onSubmit}
              >
                {submitButton?.label ?? 'Delete'}
              </SubmitConfirmButton>
            )}
          </Row>
        }
      >
        <Typography weight={400}>{content}</Typography>
      </Modal>
    </ModalContainer>
  );
};
